<template>
  <div id="app">
    <site-header v-if="!isWebView" />
    <div id="content" :class="isWebView ? 'web-view-site-content' : 'site-content'" role="main">
      <router-view />
    </div>
  </div>
</template>

<script>
import SiteHeader from 'components/SiteHeader';
import { mapActions } from 'vuex';
import ApiClient, { API } from 'api/client';
import jsonp from 'jsonp';
import config from 'config';
import DialogUtil from 'utils/dialog';
import HeaderUtil from 'utils/header';
import * as amplitude from '@amplitude/analytics-browser';

export default {
  name: 'App',
  components: {
    SiteHeader,
  },
  mixins: [ApiClient],
  computed: {
    isWebView() {
      return HeaderUtil.isWebView();
    },
  },
  created() {
    window.branch.logEvent('ENTER_PLAN_CONTRACT', { event_column: 'enter_plan_contract' }, [], 'ENTER_PLAN_CONTRACT');

    const cookieName = HeaderUtil.isWebView() ? 'auth_token' : 'plan_auth_token';
    const authToken = HeaderUtil.getCookie(cookieName);
    if (authToken !== null) {
      if (!this.$store.state.user.logged || this.$store.state.accessToken !== authToken) {
        const SsoLoginApi = this.getApi(API.SSOLOGIN);
        SsoLoginApi.checkSsoToken({ accessToken: authToken })
          .then((userInfo) => {
            this.ssoLogin(userInfo);
            this.updateAccessToken(authToken);
            jsonp(`${config.login.baseURL}/user/get_basic_info?auth_token=${authToken}`, (err, res) => {
              if (!(res.result == null)) {
                this.updateUserId({ userId: res.result.memberid });
                window.heap.identify(res.result.memberid);
                window.gtag('set', 'user_properties', {
                  user_id: res.result.memberid,
                  env: (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('socar.me') > -1) ? 'development' : 'production',
                });
                amplitude.setUserId(res.result.memberid);
              } else {
                console.log(err);
                DialogUtil.alert(res.retMsg);
              }
            });
            window.location.reload(true);
          })
          .catch(async() => {
            await SsoLoginApi.deleteCookie({ cookieName });
          });
      }
    }
  },
  methods: {
    ...mapActions('user', ['ssoLogin']),
    ...mapActions(['updateAccessToken']),
  },
};
</script>

<style>
.date-pickr {
  background-color: white !important;
}
</style>
